import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTelegram } from './hooks/useTelegram';
import { useSettingsStore } from './store/settingsStore';
import { useGameStore } from './store/gameStore';
import GameBoard from './features/game/components/GameBoard';
import './i18n/i18n';

function App() {
  const { i18n } = useTranslation();
  const { isDarkMode, isReady } = useTelegram();
  const language = useSettingsStore(state => state.language);
  const theme = useSettingsStore(state => state.theme);
  const currentGame = useGameStore(state => state.currentGame);
  const startNewGame = useGameStore(state => state.startNewGame);

  // Apply theme
  useEffect(() => {
    const root = document.documentElement;
    
    if (theme === 'auto') {
      root.classList.toggle('dark', isDarkMode);
    } else {
      root.classList.toggle('dark', theme === 'dark');
    }
  }, [theme, isDarkMode]);

  // Apply language from settings store
  useEffect(() => {
    // Always sync i18n with settings store language
    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  // Start game with medium difficulty if no game exists
  useEffect(() => {
    if (!currentGame) {
      startNewGame('medium');
    }
  }, [currentGame, startNewGame]);

  if (!isReady) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen bg-background text-foreground overflow-hidden">
      <GameBoard />
    </div>
  );
}

export default App;

